module.exports = __webpack_public_path__ + "img/IMG_20200731_202616.4920a79b.jpg";